import { API_URL } from '../../../app-config/constants';
import type MeetingSpaceDto from '../../../types/MeetingSpaceDto';
import { get } from '../request';

const ENTRY = `${API_URL}/meeting-spaces`;

const spaceId = (s: MeetingSpaceDto) => `${s.participants[0].id}:${s.participants[1].id}`;

getSharedMeetingSpaces.operation = 'READ';
getSharedMeetingSpaces.idFrom = spaceId;
export function getSharedMeetingSpaces(minUpdatedDate: Date | null) {
    return get<MeetingSpaceDto[]>(`${ENTRY}/shared`, { getData: { minUpdatedDate: minUpdatedDate?.toISOString?.() } });
}

getMyMeetingSpaces.operation = 'READ';
getMyMeetingSpaces.idFrom = spaceId;
export function getMyMeetingSpaces() {
    return get<MeetingSpaceDto[]>(`${ENTRY}/me`);
}
